import { useLocation, useNavigate, useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import Select from "react-select";
import moment from "moment/moment";
import {
  Container,
  Card,
  Row,
  Col,
  Form,
  ButtonGroup,
  Button,
} from "react-bootstrap";
import defaultPhoto from "../../2.Commons/defaultPhoto.jpg";
import { useDispatch, useSelector } from "react-redux";
import { ThreeDots } from 'react-loader-spinner';
import Swal from "sweetalert2";
import './Employee.css';
import { 
  updateForm,
  updateProrated, 
  getLeaveSummaryEmployeeYear, 
  getSickleaveSummaryEmployeeYear, 
  getMedicalbenefitLeaveSummaryEmployeeYear, 
  resignEmployee, 
  dismissEmployee,
  addLeaveProrated,
  resetProrated,
  getEmployeePhoto,
  postsearchText,
  updateTransfer,
  addtransferSupervisor,
  getAEmployee
} from "../../3.Store/EmployeeSlice";
import { getLeaveAwardedThisYear } from "../../3.Store/LeaveAwardsSlice";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { updateEntitle } from "../../3.Store/LeaveProratedSlice";

const EmployeeResignationForm = () => {
  const { id } = useParams();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const photo = useSelector((state) => state.EmployeeSlice.photo);
  const employee = useSelector((state) => state.EmployeeSlice.employeeDetail);
  const summary = useSelector((state) => state.EmployeeSlice.summaries);
  const sickLeaveSummaries = useSelector((state) => state.EmployeeSlice.sickLeaveSummaries);
  const awarded = useSelector((state) => state.LeaveAwardsSlice.awarded);
  const medicalBenefitSummaries = useSelector((state) => state.EmployeeSlice.medicalBenefitSummaries);
  const leaveProrated = useSelector((state) => state.EmployeeSlice.leaveProrated);
  const entitle = useSelector((state) => state.LeaveProratedSlice.entitle);
  const year = new Date().getFullYear();
  const { fullname, username, date_joined, date_left, status } = employee || {};
  const [loading, setLoading] = useState(false);
  const { 
    current_leave_balance,
    deduction_required,
    leave_bf,
    leave_taken_this_year,
    new_leave_balance,
    prorated_leave_awarded,
    prorated_medicalbenefit_awarded,
    prorated_sickleave_awarded,
    prorated_pct_final_year } = leaveProrated;
  const { sick_entitle, annual_entitle, medical_entitle } = entitle;
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const isSupervisor = queryParams.get("isSupervisor") === "true";
  const [selectedOption, setSelectedOption] = useState(null);
  const [inputValue, setInputValue] = useState("");
  const employees = useSelector(state => state.EmployeeSlice.employees);
  const transfer = useSelector(state => state.EmployeeSlice.transfer);

  useEffect(() => {
    window.scrollTo(0, 0);
    if (id) {
      setLoading(true);
      dispatch(getAEmployee({ id }))
        .then(() => dispatch(getLeaveAwardedThisYear({ id, year })))
        .then(() => dispatch(getLeaveSummaryEmployeeYear({ id, year })))
        .then(() => dispatch(getSickleaveSummaryEmployeeYear({ id, year })))
        .then(() => dispatch(getMedicalbenefitLeaveSummaryEmployeeYear({ id, year })))
        .then(() => dispatch(getEmployeePhoto({ id })))
        .then(() => {
          setLoading(false);
        })
        .catch(() => {
          setLoading(false);
        });
    }
  }, [id]);  
  
  useEffect(() => {
    recalculateProratedLeave();
  }, [employee.date_left]);
  
  useEffect(() => {
    if (summary && summary.length > 0) {

      const transferDetails = {
        ...transfer,
        date_left: date_left,
        oldSupervisorId: id,
        newSupervisorId: selectedOption?.id || null,
      };
      console.log(transferDetails);
      dispatch(updateTransfer(transferDetails));
      
      var date = moment(moment(date_left).format());
      var currentMonth = date.month() + 1;
      console.log(currentMonth);
      if (date.date() < 28 && date.date() > 12) {
        currentMonth -= 0.5;  // Add 1 month if before the 13th
      }
      else if (date.date() <= 12) {
        currentMonth -= 1;
      }

      console.log(currentMonth);

      var dateJoined = moment(summary[0]?.employee?.date_joined); // Convert joining date to moment object
      var dateLeft = moment(date_left); // Convert leaving date to moment object

      // Get the year for both joining and leaving
      var yearJoined = dateJoined.year();
      var yearLeft = dateLeft.year();

      var joinMonth = dateJoined.month() - 1;

      // Compare the years
      if (yearJoined === yearLeft) {
        var diff = (currentMonth - joinMonth) / (12 - joinMonth);
        console.log(diff);

      } else {
        var diff = (currentMonth) / 12;
      }

      var prorated_leave_award2 = Math.round(2 * ((summary[0]?.entitled / 12) * (12 - currentMonth)))/2;
      var new_leave_balance2 = +summary[0]?.entitled - +prorated_leave_award2;

      var prorated_sickleave_award = (sickLeaveSummaries[0]?.entitled / 12) * (12 - currentMonth);
      var prorated_medicalbenefit_award = Math.round(2 * ((medicalBenefitSummaries[0]?.entitled / 12) * (12 - currentMonth)))/2;  

      var pct_to_be_prorated = (1.0 - diff);
      var deduction_required2 = 0;

      if (new_leave_balance2 < 0) {
          deduction_required2 = (-1) *  new_leave_balance2;
          new_leave_balance2 = 0;
      };

      const entity = { ...leaveProrated, 
        leave_bf: summary[0]?.ob,
        leave_taken_this_year: summary[0]?.utilized,
        current_leave_balance: Math.round(2 * new_leave_balance2)/2,
        prorate_type: -1,
        prorate_date: moment(awarded.effective_date).format("YYYY-MM-DD"),
        // prorate_date: (yearJoined === yearLeft) ? moment().format("YYYY-MM-DD") : moment(awarded.effective_date).format("YYYY-MM-DD"),
        // year: (yearJoined === yearLeft) ? new Date().getFullYear() : moment(awarded.effective_date).year(),
        year: moment(awarded.effective_date).year(),
        new_leave_balance: Math.round(2 * new_leave_balance2)/2,
        deduction_required: Math.round(2 * deduction_required2)/2,
        // prorated_leave_awarded: Math.round(2 * prorated_leave_award2)/2,
        prorated_leave_awarded: ((Math.round(2 * prorated_leave_award2)/2) * -1),
        prorated_sickleave_awarded: ((Math.round(2 * prorated_sickleave_award)/2) * -1),
        prorated_medicalbenefit_awarded: ((Math.round(2 * prorated_medicalbenefit_award)/2) * -1),
        prorated_pct_final_year: Math.round(1000 * pct_to_be_prorated)/10,
        employee: { id: id }
      }
      console.log(entity);
      dispatch(updateProrated(entity));

      const entity_entitle = { ...entitle,
        annual_entitle: new_leave_balance,
        sick_entitle: Number(sickLeaveSummaries[0]?.entitled) - (Math.abs(prorated_sickleave_awarded)),
        medical_entitle: Number(medicalBenefitSummaries[0]?.entitled) - (Math.abs(prorated_medicalbenefit_awarded))
        // medical_entitle: Number(medicalBenefitSummaries[0]?.entitled) - (Number(medicalBenefitSummaries[0]?.utilized) + Number(medicalBenefitSummaries[0]?.prorated)) - (Math.abs(prorated_medicalbenefit_awarded))
      };
      console.log(entity_entitle);
      dispatch(updateEntitle(entity_entitle));

      const entity2 = { ...employee, 
        date_left: getDateOneMonthFromToday() 
      };
      dispatch(updateForm(entity2));
    }
  }, [summary, sickLeaveSummaries, medicalBenefitSummaries]);

  const recalculateProratedLeave = () => {

    var date = moment(moment(date_left).format());
    // Get the current month (0 = January, so add 1)
    var currentMonth = date.month() + 1;

    // Adjust the currentMonth based on the day of the month
    if (date.date() < 28 && date.date() > 12) {
      currentMonth -= 0.5;
    }
    else if (date.date() <= 12) {
      currentMonth -= 1;  // Minus 1 month if before the 13th
    }

    console.log(currentMonth);

    var dateJoined = moment(summary[0]?.employee?.date_joined); // Convert joining date to moment object
    var dateLeft = moment(date_left); // Convert leaving date to moment object

    // Get the year for both joining and leaving
    var yearJoined = dateJoined.year();
    var yearLeft = dateLeft.year();

    console.log(yearJoined, yearLeft)

    //Join Month
    var joinMonth = dateJoined.month() - 1;

    // Compare the years
    if (yearJoined === yearLeft) {
      var diff = (currentMonth - joinMonth) / (12 - joinMonth);
      console.log(diff);
    } else {
      var diff = (currentMonth) / 12;
    }

    var prorated_leave_award2 = Math.round(2 * ((summary[0]?.entitled / 12) * (12 - currentMonth)))/2;
    var new_leave_balance2 = +summary[0]?.entitled - +prorated_leave_award2;

    var prorated_sickleave_award = (sickLeaveSummaries[0]?.entitled / 12) * (12 - currentMonth);
    var prorated_medicalbenefit_award = Math.round(2 * ((medicalBenefitSummaries[0]?.entitled / 12) * (12 - currentMonth)))/2;  

    var pct_to_be_prorated = (1.0 - diff);
    var deduction_required2 = 0;

    if (new_leave_balance2 < 0) {
        deduction_required2 = (-1) *  new_leave_balance2;
        new_leave_balance2 = 0;
    };

    const entity = { ...leaveProrated, 
      new_leave_balance: Math.round(2 * new_leave_balance2)/2,
      deduction_required: Math.round(2 * deduction_required2)/2,
      prorated_leave_awarded: ((Math.round(2 * prorated_leave_award2)/2) * -1),
      prorated_sickleave_awarded: ((Math.round(2 * prorated_sickleave_award)/2) * -1),
      prorated_medicalbenefit_awarded: ((Math.round(2 * prorated_medicalbenefit_award)/2) * -1),
      prorated_pct_final_year: Math.round(1000 * pct_to_be_prorated)/10,
      current_leave_balance: Math.round(2 * new_leave_balance2)/2,
      prorate_date: moment(awarded.effective_date).format("YYYY-MM-DD"),
      year: moment(awarded.effective_date).year(),
    }
    console.log(entity);
    dispatch(updateProrated(entity));

    var sick = Number(sickLeaveSummaries[0]?.entitled) - Math.abs(entity.prorated_sickleave_awarded);
    var medical = Number(medicalBenefitSummaries[0]?.entitled) - Math.abs(entity.prorated_medicalbenefit_awarded);

    const entity_entitle = { ...entitle,
      annual_entitle: entity.new_leave_balance,
      sick_entitle: sick,
      medical_entitle: medical,
    };
    console.log(entity_entitle);
    dispatch(updateEntitle(entity_entitle));
  };

  // Calculate the date one month from today
  const getDateOneMonthFromToday = () => {
    return moment().add(2, 'months').format("YYYY-MM-DD");
  };

  const handleDate = (e) => {
    const entity = { ...employee, date_left: e.target.value }
    console.log(entity);
    dispatch(updateForm(entity));

    const entity2 = {
      ...transfer,
      date_left: e.target.value,
      newSupervisorId: selectedOption?.id || null,
      oldSupervisorId: id,
    };
    console.log(entity2);
    dispatch(updateTransfer(entity));
  };

  const handleBtnSubmit = () => {

    // if (isSupervisor && (!selectedOption || !selectedOption.id)) {
    //   Swal.fire("Error", "Please select a new supervisor for staff under " + summary[0]?.employee?.fullname, "error");
    //   return;
    // }

    const entity2 = {
      ...transfer,
      date_left: date_left,
      newSupervisorId: selectedOption?.id || null,
      oldSupervisorId: id,
    };
    console.log(entity2);

    Swal.fire({
      title: 'Are you sure?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes',
      cancelButtonText: 'No',
      reverseButtons: true
    }).then((result) => {
      if (result.isConfirmed) {
        setLoading(true);
        // dispatch(addtransferSupervisor({ ...transfer }));
        // Only dispatch addtransferSupervisor if isSupervisor is true
        if (isSupervisor) {
          dispatch(addtransferSupervisor(entity2));
        }

        const entity = { ...employee, 
          date_joined: moment(employee.date_joined).format("YYYY-MM-DD"),
          status: { id: 2 },
          id: id,
        };
        dispatch(updateForm(entity));
        const prorated = {
          ...leaveProrated,
          prorated_leave_awarded:
            annual_entitle < 0
              ? Math.abs(annual_entitle)
              : annual_entitle,
      
          prorated_sickleave_awarded:
            sick_entitle < 0
              ? Math.abs(sick_entitle)
              : sick_entitle,
      
          prorated_medicalbenefit_awarded:
            medical_entitle < 0
              ? Math.abs(medical_entitle)
              : medical_entitle,
          // prorated_leave_awarded:
          //   leaveProrated.prorated_leave_awarded < 0
          //     ? Math.abs(leaveProrated.prorated_leave_awarded)
          //     : leaveProrated.prorated_leave_awarded,
      
          // prorated_sickleave_awarded:
          //   leaveProrated.prorated_sickleave_awarded < 0
          //     ? Math.abs(leaveProrated.prorated_sickleave_awarded)
          //     : leaveProrated.prorated_sickleave_awarded,
      
          // prorated_medicalbenefit_awarded:
          //   leaveProrated.prorated_medicalbenefit_awarded < 0
          //     ? Math.abs(leaveProrated.prorated_medicalbenefit_awarded)
          //     : leaveProrated.prorated_medicalbenefit_awarded,
        }
        dispatch(addLeaveProrated({ date_left: employee.date_left, ...prorated, employee: {id: id} }))
          .unwrap()
          .then(() => {
            return dispatch(resignEmployee({ id: id, date_left: employee.date_left })).unwrap();
          })
          .then(() => {
            return dispatch(dismissEmployee({ id: id, ...entity })).unwrap();
          })
          // .then(() => {
          //   return dispatch(dismissUser({ id: employee.id, status: { id: 1 } })).unwrap();
          // })
          .then(() => {
            setLoading(false);
            Swal.fire({
              title: summary[0]?.employee?.fullname + ' has resigned',
              icon: 'success',
              confirmButtonText: 'OK'
            }).then((result) => {
              if (result.isConfirmed) {
                // navigate(-1);
                navigate("/EmployeeList")
              }
            });
          })
          .catch((err) => {
            setLoading(false);
            Swal.fire("Error", err.response.data, "error");
          });
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        Swal.fire('Cancelled', 'Cancel Resign Employee', 'error');
      }
    });
  };

  const handleBtnCancel = () => {
    dispatch(resetProrated());
    navigate(-1);
  };

  const handleChangeLeaveProrated = (e) => {
    const entity = { ...leaveProrated, [e.target.name]: e.target.value };

    var date = moment(moment(date_left).format());
    var currentMonth = date.month() + 1;
    console.log(currentMonth);

    // Adjust the currentMonth based on the day of the month
    if (date.date() < 28 && date.date() > 12) {
      currentMonth -= 0.5;  // Add 1 month if before the 13th
    }
    else if (date.date() <= 12) {
      currentMonth -= 1;
    }

    var dateJoined = moment(date_joined); // Convert joining date to moment object
    var dateLeft = moment(date_left); // Convert leaving date to moment object

    // Get the year for both joining and leaving
    var yearJoined = dateJoined.year();
    var yearLeft = dateLeft.year();

    //Join Month
    var joinMonth = dateJoined.month() - 1;

    // Compare the years
    if (yearJoined === yearLeft) {
      // var joinMonth = dateJoined.month() + 1;
      var diff = (currentMonth - joinMonth) / (12 - joinMonth);
    } else {
      var diff = (currentMonth) / 12;
    }

    let pct_to_be_prorated = 1.0 - diff;
    var prorated_leave_award2 = entity.prorated_leave_awarded;
    // var new_leave_balance2 = +summary[0]?.cf - +prorated_leave_award2;
    var balance = Number(summary[0]?.entitled) - Number(summary[0]?.utilized);
    var new_leave_balance2 = (Number(summary[0]?.entitled) - balance - Math.abs(prorated_leave_award2));
    let deduction_required2 = 0;

    var sick = Number(sickLeaveSummaries[0]?.entitled) - (Number(sickLeaveSummaries[0]?.utilized) + Number(sickLeaveSummaries[0]?.prorated)) - Math.abs(entity.prorated_sickleave_awarded);
    var medical = Number(medicalBenefitSummaries[0]?.entitled) - (Number(medicalBenefitSummaries[0]?.utilized) + Number(medicalBenefitSummaries[0]?.prorated)) - Math.abs(entity.prorated_medicalbenefit_awarded);
    // if (new_leave_balance2 < 0) {
    //   deduction_required2 = (-1) *  new_leave_balance2;
    //   new_leave_balance2 = 0;
    // }

    entity.new_leave_balance = Math.round(new_leave_balance2 * 2) / 2;
    entity.deduction_required = Math.round(deduction_required2 * 2) / 2;
    entity.prorated_leave_awarded = ((Math.round(2 * entity.prorated_leave_awarded)/2) * -1);
    entity.prorated_pct_final_year = Math.round(pct_to_be_prorated * 1000) / 10;

    console.log(entity);
    dispatch(updateProrated(entity));

    const entity_entitle = { ...entitle,
      annual_entitle: entity.new_leave_balance,
      sick_entitle: sick,
      medical_entitle: medical,
    };
    console.log(entity);
    dispatch(updateEntitle(entity_entitle));
  };

  const handleChangeLeaveBalance = (e) => {
    const entity = { ...entitle, [e.target.name]: e.target.value };

    var annual_prorated = Number(summary[0]?.cf) - Number(entity.annual_entitle);

    const entity_prorated = { ...leaveProrated,
      prorated_leave_awarded: annual_prorated,
      prorated_sickleave_awarded: Number(sickLeaveSummaries[0]?.bal) - Number(entity.sick_entitle),
      prorated_medicalbenefit_awarded: Number(medicalBenefitSummaries[0]?.bal) - Number(entity.medical_entitle),
      new_leave_balance: annual_prorated,
    };
    console.log(entity_prorated);
    dispatch(updateProrated(entity_prorated));

    console.log(entity);
    dispatch(updateEntitle(entity));
  };

  useEffect(() => {
    if (inputValue && inputValue.length > 2) {
      const entity = { searchText: inputValue, active: 1}
      dispatch(postsearchText(entity));
    }
  }, [inputValue]);

  const handleDropdownSupervisor = (selectedOption) => {
    setSelectedOption(selectedOption);
  
    const entity = {
      ...transfer,
      newSupervisorId: selectedOption?.id || null,
      oldSupervisorId: id,   // retain or reapply oldSupervisorId
      date_left: date_left,
    };
    console.log(entity);
    dispatch(updateTransfer(entity));
  };

  // Map employee names to options
  const options = employees.map(employee => ({
    label: employee.fullname,
    value: employee.fullname,
    id: employee.id
  }));

  return (
    <Container className="ContainerContent">
      {loading && (
          <ThreeDots
          visible={loading}
          height="80"
          width="80"
          color="#4fa94d"
          radius="9"
          ariaLabel="three-dots-loading"
          wrapperStyle={{
            position: 'fixed',
            top: '0',
            left: '0',
            width: '100%',
            height: '100%',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            backgroundColor: 'rgba(0, 0, 0, 0.5)',
            zIndex: '9999',
          }}
          />
      )}
      <Card className="CardContent">
        <div className="d-flex justify-content-between">
          <ButtonGroup className="my-2">
            <Button className="Button" onClick={handleBtnCancel}>
              Back
            </Button>
          </ButtonGroup>
        </div>
        <h1 className="TitleHeader">Employee Resignation</h1>

        <Row className="my-3">
          <Col md={6} sm={6}>
            <Row className="my-3 containerStyle">
              <img src={photo?.photo || defaultPhoto} alt="Employee Photo" className="ovalImageStyle"/><br /><br />
            </Row>
            <Row className="my-3">
              <Col md={4} sm={4}>
                <Form.Label className="FormLabel">Fullname</Form.Label>
              </Col>
              <Col md={8} sm={8}>
                <Form.Control value={summary[0]?.employee?.fullname} readOnly disabled/>
              </Col>
            </Row>
            <Row className="my-3">
              <Col md={4} sm={4}>
                <Form.Label className="FormLabel">Username</Form.Label>
              </Col>
              <Col md={8} sm={8}>
                <Form.Control value={summary[0]?.employee?.username} readOnly disabled/>
              </Col>
            </Row>
            {/* <Row className="my-3">
              <Col md={4} sm={4}>
                <Form.Label className="FormLabel">{summary[0]?.employee?.status?.description}</Form.Label>
              </Col>
            </Row> */}
            
            {/* {isSupervisor && (
              <Row className="my-3">
              <Col md={4} sm={4}>
                <Form.Label className="FormLabel">Transfer Staff to</Form.Label>
              </Col>
              <Col md={8} sm={8}>
                <Select
                  inputValue={inputValue}
                  onInputChange={(value) => setInputValue(value)}
                  name="supervisor"
                  onChange={handleDropdownSupervisor}
                  options={options}
                  value={selectedOption}
                  placeholder="Select Supervisor"
                />
              </Col>
            </Row>
            )} */}
          </Col>

          <Col md={6} sm={6}>
            <Row className="my-3">
              <Col md={4} sm={4}>
                <Form.Label className="FormLabel">Date Join</Form.Label>
              </Col>
              <Col md={8} sm={8}>
                <Form.Control value={moment(summary[0]?.employee?.date_joined).format("YYYY-MM-DD")} readOnly disabled/>
              </Col>
            </Row>
            <Row className="my-3">
              <Col md={4} sm={4}>
                <Form.Label className="FormLabel">Date Leaving</Form.Label>
              </Col>
              <Col md={8} sm={8}>
                {/* <Form.Control type="date" name="date_left" value={moment(date_left).format("YYYY-MM-DD")} onChange={handleDate}/> */}
                <DatePicker
                  selected={date_left ? new Date(date_left) : null}
                  onChange={(date) =>
                    handleDate({
                      target: {
                        name: "date_left",
                        value: moment(date).format("YYYY-MM-DD"),
                      },
                    })
                  }
                  dateFormat="yyyy-MM-dd"
                  className="form-control w-100 datepicker-icon"
                />
              </Col>
            </Row>

            {/* <hr/>
            <Row className="my-3">
              <Col md={4} sm={4}>
                <Form.Label className="FormLabel">Leave Brought Forward</Form.Label>
              </Col>
              <Col md={8} sm={8}>
                <Form.Control name="leave_bf" value={leave_bf} readOnly disabled/>
              </Col>
            </Row> */}

            {/* <Row className="my-3">
              <Col md={4} sm={4}>
                <Form.Label className="FormLabel">Leave Awarded For This Year</Form.Label>
              </Col>
              <Col md={8} sm={8}>
                <Form.Control name="leave_awarded_this_year" value={summary[0]?.entitled} onChange={handleChangeLeave}/>
              </Col>
            </Row>
            <Row className="my-3">
              <Col md={4} sm={4}>
                <Form.Label className="FormLabel">Leave Taken This Year</Form.Label>
              </Col>
              <Col md={8} sm={8}>
                <Form.Control name="leave_taken_this_year" value={leave_taken_this_year} onChange={handleChangeLeave}/>
              </Col>
            </Row>
            <Row className="my-3">
              <Col md={4} sm={4}>
                <Form.Label className="FormLabel">Current Leave Balance</Form.Label>
              </Col>
              <Col md={8} sm={8}>
                <Form.Control name="current_leave_balance" value={current_leave_balance} onChange={handleChangeLeave}/>
              </Col>
            </Row> */}

            <hr/>

            <Row className="my-3">
              <Col md={4} sm={1}></Col>

              <Col md={8}>
                <div className="d-flex gap-3">
                  <Form.Label className="FormLabel fs-6 flex-fill text-center" style={{marginLeft: '-7px'}}>Awarded</Form.Label>
                  {/* <Form.Label className="FormLabel fs-6 flex-fill text-center" style={{marginLeft: '-8px'}}>Utilized</Form.Label>
                  <Form.Label className="FormLabel fs-6 flex-fill text-center" style={{marginLeft: '-10px'}}>Prorated</Form.Label> */}
                  <Form.Label className="FormLabel fs-6 flex-fill text-center" style={{marginLeft: '-10px'}}>Entitled</Form.Label>
                </div>
              </Col>
            </Row>

            <Row className="my-3 align-items-center">
              <Col md={4}>
                <Form.Label className="FormLabel fs-6">Annual Leave</Form.Label>
              </Col>

              <Col md={8}>
                <div className="d-flex gap-3">
                  <Form.Control
                    value={summary[0]?.entitled}
                    className="fs-6 flex-fill text-center"
                    readOnly
                    disabled
                  />
                  {/* <Form.Control
                    value={Math.abs(Number(summary[0]?.utilized) + Number(summary[0]?.prorated)).toFixed(1)}
                    className="fs-6 flex-fill text-center"
                    readOnly
                    disabled
                  />
                  <Form.Control
                    type="number"
                    name="prorated_leave_awarded"
                    value={Math.abs(prorated_leave_awarded).toFixed(1)}
                    onChange={handleChangeLeaveProrated}
                    className="fs-6 flex-fill text-center"
                  /> */}
                  <Form.Control
                    type="number"
                    name="annual_entitle"
                    // value={Number(summary[0]?.entitled) - Number(summary[0]?.cf) - (prorated_leave_awarded * -1)}
                    value={Number(annual_entitle).toFixed(1)}
                    onChange={handleChangeLeaveBalance}
                    className="fs-6 flex-fill text-center"
                  />
                </div>
              </Col>
            </Row>

            <Row className="my-3 align-items-center">
              <Col md={4}>
                <Form.Label className="FormLabel fs-6">Sick Leave</Form.Label>
              </Col>

              <Col md={8}>
                <div className="d-flex gap-3">
                  <Form.Control
                    value={sickLeaveSummaries[0]?.entitled}
                    className="fs-6 flex-fill text-center"
                    readOnly
                    disabled
                  />
                  {/* <Form.Control
                    value={Math.abs(Number(sickLeaveSummaries[0]?.entitled) - Number(sickLeaveSummaries[0]?.bal)).toFixed(1)}
                    className="fs-6 flex-fill text-center"
                    readOnly
                    disabled
                  />
                  <Form.Control
                    type="number"
                    name="prorated_sickleave_awarded"
                    value={Math.abs(prorated_sickleave_awarded).toFixed(1)}
                    onChange={handleChangeLeaveProrated}
                    className="fs-6 flex-fill text-center"
                  /> */}
                  <Form.Control
                    type="number"
                    name="sick_entitle"
                    value={Number(sick_entitle).toFixed(1)}
                    onChange={handleChangeLeaveBalance}
                    // value = {Number(sickLeaveSummaries[0]?.entitled) - (Number(sickLeaveSummaries[0]?.utilized) + Number(sickLeaveSummaries[0]?.prorated)) - (Math.abs(prorated_sickleave_awarded))}
                    className="fs-6 flex-fill text-center"
                  />
                </div>
              </Col>
            </Row>

            <Row className="my-3 align-items-center">
              <Col md={4}>
                <Form.Label className="FormLabel fs-6">Medical Claim</Form.Label>
              </Col>

              <Col md={8}>
                <div className="d-flex gap-3">
                  <Form.Control
                    value={Math.abs(medicalBenefitSummaries[0]?.entitled).toFixed(1)}
                    className="fs-6 flex-fill text-center"
                    readOnly
                    disabled
                  />
                  {/* <Form.Control
                    value={Math.abs(Number(medicalBenefitSummaries[0]?.entitled) - Number(medicalBenefitSummaries[0]?.bal)).toFixed(1)}
                    className="fs-6 flex-fill text-center"
                    readOnly
                    disabled
                  />
                  <Form.Control
                    type="number"
                    name="prorated_medicalbenefit_awarded"
                    value={Math.abs(prorated_medicalbenefit_awarded).toFixed(1)}
                    onChange={handleChangeLeaveProrated}
                    className="fs-6 flex-fill text-center"
                  /> */}
                  <Form.Control
                    type="number"
                    name="medical_entitle"
                    value={Number(medical_entitle).toFixed(1)}
                    // value={medical_entitle}
                    onChange={handleChangeLeaveBalance}
                    // value = {Number(medicalBenefitSummaries[0]?.entitled) - (Number(medicalBenefitSummaries[0]?.utilized) + Number(medicalBenefitSummaries[0]?.prorated)) - (Math.abs(prorated_medicalbenefit_awarded))}
                    className="fs-6 flex-fill text-center"
                  />
                </div>
              </Col>
            </Row>

            <Row className="my-3">
              <p style={{ color: 'yellow', fontSize: '1.1rem' }}>
                Entitled = Leave balance after deductions (e.g. Leave Awarded - Leave Deductions)
              </p>
            </Row>

            {/* <Row className="my-3">
              <Col md={4} sm={4}>
                <Form.Label className="FormLabel">Prorated Leave Award</Form.Label>
              </Col>
              <Col md={8} sm={8}>
                <Form.Control name="prorated_leave_awarded" value={prorated_leave_awarded * -1} onChange={handleChangeLeaveProrated} />
              </Col>
            </Row>
            <Row className="my-3">
              <Col md={4} sm={4}>
                <Form.Label className="FormLabel">Entitled Leave to be deducted (%)</Form.Label>
              </Col>
              <Col md={8} sm={8}>
                <Form.Control name="prorated_pct_final_year" value={prorated_pct_final_year} onChange={handleChangeLeaveProrated} />
              </Col>
            </Row>
            <Row className="my-3">
              <Col md={4} sm={4}>
                <Form.Label className="FormLabel">New Leave Balance</Form.Label>
              </Col>
              <Col md={8} sm={8}>
                <Form.Control name="new_leave_balance" value={new_leave_balance} onChange={handleChangeLeaveProrated} />
              </Col>
            </Row>
            <Row className="my-3">
              <Col md={4} sm={4}>
                <Form.Label className="FormLabel">Deduction Required</Form.Label>
              </Col>
              <Col md={8} sm={8}>
                <Form.Control name="deduction_required" value={deduction_required} onChange={handleChangeLeaveProrated} />
              </Col>
            </Row> */}
          </Col>
        </Row>

        <div className="d-flex justify-content-between my-2">
          <ButtonGroup>
            <Button className="Button" onClick={handleBtnCancel}>
              Back
            </Button>
          </ButtonGroup>
          <ButtonGroup>
            {/* <Button className="Button" onClick={handleBtnPrint}>
              Print
            </Button>
            &nbsp; &nbsp; */}
            <Button className="Button" onClick={handleBtnSubmit}>
              Submit
            </Button>
          </ButtonGroup>
        </div>
      </Card>
    </Container>
  );
};
export default EmployeeResignationForm;